import { FaSun, FaMoon } from "react-icons/fa";
import { useTheme } from "./theme-provider";
import { motion } from "framer-motion";

export const ThemeToggle = () => {
    const theme = useTheme();

    const toggleVariants = {
        light: {
            rotate: 0,
            scale: 1,
        },
        dark: {
            rotate: 360,
            scale: 1,
        },
    };

    const iconVariants = {
        initial: {
            opacity: 0,
            scale: 0.5,
            rotate: -180,
        },
        animate: {
            opacity: 1,
            scale: 1,
            rotate: 0,
            transition: {
                duration: 0.3,
                ease: "easeOut",
            },
        },
        exit: {
            opacity: 0,
            scale: 0.5,
            rotate: 180,
            transition: {
                duration: 0.3,
                ease: "easeIn",
            },
        },
    };

    return (
        <motion.button
            onClick={theme.toggle}
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800
                     hover:bg-gray-200 dark:hover:bg-gray-700
                     text-yellow-500 dark:text-blue-300
                     shadow-md hover:shadow-lg
                     transform-gpu bottom-4 left-4 fixed"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            animate={theme.current}
            variants={toggleVariants}
            transition={{ type: "spring", duration: 0.7 }}
            aria-label="Toggle theme"
        >
            <motion.div
                initial="initial"
                animate="animate"
                exit="exit"
                variants={iconVariants}
                key={theme.current}
            >
                {theme.current === "dark" ? (
                    <FaSun className="w-5 h-5" />
                ) : (
                    <FaMoon className="w-5 h-5" />
                )}
            </motion.div>
        </motion.button>
    );
};
